import React from "react";
import { Form, Input } from "antd";
import { BiMap } from "react-icons/bi";

const PaymentAddressState = (props) => {
  // -------------------------- VAR --------------------------
  const { disabled } = props;
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- FUNCTION --------------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN --------------------------
  return (
    <Form.Item
      name="state"
      label="State / Region"
      rules={[
        {
          required: false,
          message: "Please input State / Region",
        },
        {
          whitespace: true,
          message: "Please input State / Region",
        },
      ]}
    >
      <Input
        prefix={<BiMap className="form-item-icon" />}
        placeholder="State / Region"
        disabled={disabled}
      />
    </Form.Item>
  );
};

export default PaymentAddressState;
